import { request } from "configs/api";
import {
  GetUserInfoResponseDto,
  SubmitChangePasswordDto,
} from "interfaces/user";

class UserService {
  fetchMe(): Promise<GetUserInfoResponseDto> {
    return request({
      url: "/auth/user/info",
      method: "GET",
    });
  }

  changePassword(data: SubmitChangePasswordDto): Promise<undefined> {
    return request({
      data,
      url: "/auth/user/change-password",
      method: "PATCH",
    });
  }
}

export const userService: UserService = new UserService();
